<template>
  <div class="cb-account-locked" @keydown="setFocus">
    <p class="cb-body-1" id="dialog-title">
      For your security, <strong>this account has been locked</strong>
      in response to several failed login attempts.
      Please try back in 30 minutes.
    </p>
    <div class="cb-account-locked__btn-container">
      <button
        @click="closeModal"
        ref="closeModalButton"
        class="cb-button cb-button--no-outline"
      >GOT IT</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import focusTrapping from '../../mixins/focusTrapping';

export default {
  mounted() {
    this.$refs.closeModalButton.focus();
  },
  methods: {
    ...mapActions(['closeModal']),
  },
  mixins: [focusTrapping],
};
</script>

<style lang="scss" scoped>
.cb-account-locked {
  width: 88vw;
  max-width: 430px;
  box-sizing: border-box;
  padding: 24px 24px 10px;

  .cb-body-1 {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 16px;
  }

  &__btn-container {
    display: flex;
    justify-content: flex-end;
  }

  @include desktop {
    padding: 24px 40px 10px;
  }
}
</style>
